// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import PerkStarIcon from './PerkStarIcon';
import styles from '../styles/CircleStarProgressBar.style';

const CircleStarProgressBar = (props) => {
  const { className, percentage, variant, earnedPerkValue, maxPerkValue } = props;
  const percentageAbove50 = percentage > 50 ? 'over50' : '';

  return (
    <div className={className}>
      <div className={`progress-circle ${percentageAbove50}`}>
        {variant === 'default' ? (
          <div className="progress-text">
            <span className="perks-earned-point">
              <sup className="perks-dollar-symbol">$</sup>
              {earnedPerkValue}
            </span>
            <span className="perks-max-point">
              {'/'} {maxPerkValue}
            </span>
          </div>
        ) : (
          <div className="star-image">
            <PerkStarIcon />
          </div>
        )}
        <div className="left-half-clipper">
          <div className="first50-bar" />
          <div className="value-bar" />
        </div>
      </div>
    </div>
  );
};

CircleStarProgressBar.propTypes = {
  className: PropTypes.string,
  percentage: PropTypes.number.isRequired,
  earnedPerkValue: PropTypes.number,
  maxPerkValue: PropTypes.number,
  variant: PropTypes.string,
  size: PropTypes.string,
  hideProgressBar: PropTypes.bool,
  isPerkNotReached: PropTypes.bool,
};

CircleStarProgressBar.defaultProps = {
  className: '',
  variant: 'rockstar',
  size: 'large',
  hideProgressBar: false,
  isPerkNotReached: false,
};

export default withStyles(CircleStarProgressBar, styles);
export { CircleStarProgressBar as CircleStarProgressBarVanilla };
